export const environment = {
    production: true,
    useMock: false,
    apiHost: 'https://hanabcheck-a.hanab.nl',
    redirectUri: 'https://hanabcheck.hanab.nl/authenticate',
    imageOptions: {
        annotationVersion: 3,
        imageWidth: 1600,
        imageHeight: 1200,
    }
};
